import createReactClass from 'create-react-class';
'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Store from '../_utils/tools/store';
import FileSelectorMixin from './loader-mixins/file-selector-mixin';
import UrlLoaderUploadMixin from './loader-mixins/url-loader-upload-mixin';
import FileClearingMixin from './loader-mixins/file-clearing-mixin';
import BeethovenFrieze from 'libs/beethoven-frieze';
import PrintSizeSelector from './print-size-selector';
import LoaderAdditionalOptions from './additional-options';
import { builderDispatch, WebUI } from "../_utils/ui";
import ServiceHeader from './album-import/service-header';

const themeName = (() => {
  if (!Store.isWalmart()) {
    return Store.name.toLowerCase();
  }
})();

const CloudImport = createReactClass({
  mixins: [UrlLoaderUploadMixin, FileSelectorMixin, FileClearingMixin],
  displayName: 'Cloud import',

  getInitialState() {
    return {
      albumName: null
    };
  },

  componentDidMount() {
    this.dispatchToken = builderDispatch.register(payload => {
      switch (payload.type) {
        case (WebUI.UPLOAD_PHOTO_REMOVED_FROM_TRAY):
          this.handlePhotoRemoved(payload.key, payload.service);
          break;
        case (WebUI.UPLOAD_ALL_PHOTOS_REMOVED_FROM_TRAY):
          this.handleAllPhotosRemoved();
          break;
      }
    });
  },

  UNSAFE_componentWillMount() {
    this.getIframeUrl();
    BeethovenFrieze.onImageSelected(({ url, thumb, filename, originalKey, foreignUserId = null, }) => {
      if (this.props.isActive) {
        if (url === decodeURI(url)) {
          url = encodeURI(url);
        }
        originalKey = String(originalKey || url);

        this.files = (this.files || []);

        // avoid duplicates
        if (this.files.some(file => file.originalKey === originalKey)) {
          return;
        }

        this.files.push({
          url: url,
          thumb: thumb,
          filename: filename,
          source: 'url',
          originalKey: originalKey,
          foreignUserId: foreignUserId,
        });
      }
    });

    BeethovenFrieze.onComplete(() => {
      if (this.props.isActive) {
        this.props.onFilesSelected();
      }
    });

    BeethovenFrieze.onTrayImageRemoved((data) => {
      const dataKey = String(data.url || data);
      if (this.props.isActive) {
        this.files = (this.files || []);
        this.files = this.files.filter(file => file.originalKey !== dataKey);
        this.props.onFilesSelected();
      }
    });

    BeethovenFrieze.onAlbumEntry((data) => {
      if (this.props.isActive && data !== 'root') {
        this.setState({
          albumName: data
        });
        this.props.onHideMenu(true);
      }

      if (this.props.isActive && data === 'root') {
        this.handleShowAlbums('root');
      }
    })
  },

  render() {
    let iframeUrl = this.iframeUrl ? this.iframeUrl : 'about:blank';

    if (!this.iframeUrl && (this.shown_already || this.props.isActive)) {
      iframeUrl = BeethovenFrieze.generateServiceUrl(this.props.service, { theme: themeName }, false);
      this.shown_already = true;
    }

    return (
      <div>
        {this.props.isActive && this.state.albumName &&
          <ServiceHeader
            title={this.state.albumName}
            onBackClick={() => { this.handleShowAlbums('handle_back') }}
          />
        }
        <div id={`image-loader-service-${this.props.service}`}
          className={classNames("image-loader-service", "cloud", { "cloud-album": this.state.albumName }, { "d-none": !this.props.isActive }, this.props.service, { "has-additional-options": this.context.additionalOptions[LoaderAdditionalOptions.PRINT_SIZES] })}
          style={{ height: this.props.height }}>
          <div className="iframe-container">
            <iframe
              aria-label={`${this.props.title} service frame`}
              className="image-loader-iframe"
              frameBorder="0"
              id={`image-loader-iframe-${this.props.service}`}
              ref={ref => this.iFrame = ref}
              src={iframeUrl}
              title={`${this.props.title} service frame`}
            />
          </div>
        </div>
      </div>
    );
  },

  handlePhotoRemoved(key, service) {
    if (service === this.props.service) {
      const message = `tray_image_removed:${key}`;
      BeethovenFrieze.sendMessage(this.iFrame, message);
    }
  },

  handleAllPhotosRemoved() {
    (this.files || []).forEach(file => this.handlePhotoRemoved(file.originalKey || file.url));
  },

  handleShowAlbums(actionName) {
    if (this.props.isActive) {
      this.props.onHideMenu(false);
      this.setState({
        albumName: null
      });
      const message = `on_album_entry:` + actionName;
      BeethovenFrieze.sendMessage(this.iFrame, message);
    }
  },

  getIframeUrl() {
    const source = window.urls || {};
    const list = source.cloudServices || {};

    this.iframeUrl = list[this.props.service];
  }
});

CloudImport.contextTypes = {
  additionalOptions: PropTypes.object
};

export default CloudImport;
